module.exports = __webpack_public_path__ + "static/b-medicina-fetal-dbd4fa4055bdaec610a599cbb6f0a5b5.jpg";